import { Component, EnvironmentInjector, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddCourseModalComponent } from '../../modals/add-course-modal/add-course-modal.component';
import { BaseComponent } from 'src/app/core/base.component';
import { SessionService } from '../../services/session.service';
import { CourseService } from 'src/app/administration/course/course.service';
import { Observable } from 'rxjs';
import { Course } from 'src/app/administration/course/course';
import { map, startWith } from 'rxjs/operators';
import { Form, FormControl, FormGroup } from '@angular/forms';
import { StringHelpers } from '../../helpers/string-helpers';

@Component({
    selector: 'course-select-create',
    templateUrl: './course-select-create.component.html',
    styleUrl: './course-select-create.component.scss',
    standalone: false
})
export class CourseSelectCreateComponent extends BaseComponent implements OnInit {
  public courses: Course[] = [];
  public filteredCourses: Observable<Course[]>;
  public addCourse: boolean = false;
  public form = new FormGroup({
    courseId: new FormControl(),
  });

  @Output() public courseEvent = new EventEmitter<Course>();
  @Output() public isLoadingEvent = new EventEmitter<boolean>();

  constructor(sessionService: SessionService,
    public dialog: MatDialog,
    private courseService: CourseService,
    stringHelpers: StringHelpers,
  ) {
    super(sessionService, stringHelpers);
  }

  ngOnInit() {
    this.getCourses();
  }

  getCourses() {
    this.onIsLoadingEvent(true);
    this.courseService.getAll().subscribe(results => {
      this.courses = results;
      this.filteredCourses = this.form.get('courseId')!.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.name),
        map(name => name ? this.filter(name) : this.courses.slice())
      );
      this.onIsLoadingEvent(false);
    }, err => {
      this.onIsLoadingEvent(false);
      console.error(err);
    });
  }

  addCourseModal() {
    const dialogRef = this.dialog.open(AddCourseModalComponent, {
      width: '45vw'
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response !== 'cancel') {
        delete response.id;
        response.createdBy = this.sessionService.getUserId();
        this.courseService.create(response).subscribe(result => {
          this.getCourses();
          this.form.get('courseId').patchValue(result);
          this.filter(response.name);
          this.displayCourseName(result);
          this.courseEvent.emit(result);
        }, err => {
          this.setError(err, this.form);
          this.onIsLoadingEvent(false);
        });
      }
    });
  }

  private filter(value: string): Course[] {
    const filterValue = value.toLowerCase();
    let course = this.courses.filter(option => option.name.toLowerCase().includes(filterValue));
    return course;
  }

  displayCourseName = (course: Course) => {
    if (course !== null) {
      this.courseEvent.emit(course);
    }
    return course && course.name ? course.name : '';
  }

  onIsLoadingEvent(value) {
    this.isLoading = value;
    this.isLoadingEvent.emit(value);
  }
}
